import * as React from "react"
import { AiOutlineQuestionCircle } from "react-icons/ai"
import {
  Box,
  Button,
  IconButton,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react"
import NextLink from "next/link"
import { useRouter } from "next/router"
import "dayjs/locale/nl"

import { useLocalStorage } from "../lib/hooks/useLocalStorage"
import { useMe } from "../lib/hooks/useMe"

export function ProfileWelcomeModal() {
  const [isOpen, setIsOpen] = useLocalStorage("kb:welcome:modal", true)
  const router = useRouter()
  const { me } = useMe()

  const handleClick = () => {
    if (!me) return null
    router.replace(`/users/${me.customSlug ? me.customSlug : me.id}/edit`)
    setIsOpen(false)
  }

  return (
    <Box>
      <IconButton
        icon={<AiOutlineQuestionCircle />}
        aria-label="hulp"
        variant="ghost"
        onClick={() => setIsOpen(true)}
        size="xs"
        ml={2}
      />
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Hey,</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              Welkom op jouw eigen account. En wat nu? Klik op de verschillende onderdelen in jouw account en
              ontdek Kunstbende!
              <br />
              <br />
              Wil je meteen een act aanmaken? Ga naar{" "}
              <span>
                <NextLink href="/wedstrijd" passHref>
                  <Link color="yellow.500" fontWeight="bold">
                    WEDSTRIJD
                  </Link>
                </NextLink>
                &nbsp;
              </span>
            </Text>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="yellow" mr={3} onClick={handleClick}>
              Let's go!
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}
